class themeRegister {

    static value = null;
    static theme = null;

    static setValue(value){
        themeRegister.value = value;
        try {
            sessionStorage.setItem('theme-data', JSON.stringify(themeRegister.value));
        }catch (e) {}
    }

    static setTheme(theme){
        themeRegister.theme = theme;
        try {
            sessionStorage.setItem('theme', themeRegister.theme);
        }catch (e) {}
    }

    static getValue(){
        try {
            if(sessionStorage.getItem('theme-data')){
                let value =  JSON.parse(sessionStorage.getItem('theme-data'));
                return value;
            }else{
                return themeRegister.value;
            }
        }catch (e) {
            return themeRegister.value;
        }
    }

    static getTheme(){
        try {
            if(sessionStorage.getItem('theme')){
                let theme = sessionStorage.getItem('theme');
                return theme;
            }else{
                return themeRegister.theme;
            }
        }catch (e) {
            return themeRegister.theme;
        }
    }

    static remove(){
        try {
            sessionStorage.removeItem('theme');
            sessionStorage.removeItem('theme-data');
        }catch (e) {}
        themeRegister.value = null;
        themeRegister.theme = null;
    }

}

export {themeRegister}


// WEBPACK FOOTER //
// ./src/services/themeRegister.js